import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { PushAndTrackService } from '../../../../../../../core/outputs/annotation/annotation-shared/utils/push-and-track.service';
import { ShapeSelectionService } from '../../../../../../../core/outputs/annotation/annotation-shared/utils/shape-selection.service';
import { ShapeGroupingService } from '../../../../../../../core/shared/misc-services/shape-grouping.service';
import { getShapesForEventTracking } from '../../../../../../../cross-team-shared/annotation/shared/state/layers/shape-layer-state';
import { outputAnnotationInfoStoreToken } from '../../../../annotation-providers';

@Component({
  selector: 'h3-group-shapes-button',
  templateUrl: './group-shapes-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GroupShapesButtonComponent {
  @Input({ required: true }) groupTypes!: string[];

  private readonly shapeGroupingService = inject(ShapeGroupingService);
  private readonly shapesStore = inject(outputAnnotationInfoStoreToken)(
    'shapes',
  );

  faLink = faLink;
  selectedShapeCount$ = this.selectionService.getSelectedShapeCount$();

  constructor(
    private pushAndTrackService: PushAndTrackService,
    private selectionService: ShapeSelectionService,
  ) {}

  groupShapes(groupType: string) {
    const newGroup = this.shapeGroupingService.groupShapes(groupType);
    const shapesForEventTracking = getShapesForEventTracking(
      // @ts-ignore -- fix me
      this.shapesStore.state(),
      // fix me if you change this code
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
      newGroup?.shapeIndexes ?? [],
    );

    this.pushAndTrackService.pushAndTrack({
      id: 'group_shapes',
      bucket: 'tag_selection',
      shapes: shapesForEventTracking,
      group_type: groupType,
    });
  }
}
